import { Button } from "@/components/ui/button";
import { useGetCards, useGetPendingCards } from "@/hooks/use-queries";
import { useModalStore } from "@/zustand/modalStore";
import { useSheetStore } from "@/zustand/sheetStore";
import moment from "moment";
import { useState } from "react";

const PendingCards = ({ closeSheet }) => {
  const { data: cards, isLoading: cardIsLoading } = useGetPendingCards();
  const [selectedCard, setSelectedCard] = useState<PendingCard | null>(null);

  return (
    <div className="mt-4 px-2 text-white">
      <h2 className="font-semibold">Card creation in progress</h2>

      <div className="mt-4">
        <h4 className="text-sm">Select card to see your details</h4>
        {cardIsLoading ? (
          <div className="relative mt-6 flex flex-col gap-4">
            {[1, 2, 3].map((index) => (
              <CardSkeleton key={index} />
            ))}
          </div>
        ) : cards?.data.length > 0 ? (
          <div>
            <div className="mt-6 flex flex-col gap-4">
              {cards?.data.map((card: PendingCard) => (
                <Card
                  selectedCard={selectedCard}
                  setSelectedCard={setSelectedCard}
                  cardData={card}
                  key={card.id}
                />
              ))}
            </div>
            <div className="mt-6">
              <Button
                onClick={() => {
                  closeSheet();
                }}
                className="text-primary-500 bg-primary-100 h-10 w-full hover:bg-[#B0D4F0`]"
              >
                Close
              </Button>
            </div>
          </div>
        ) : (
          <div className="w- flex h-100 items-center justify-center">
            <div className="flex flex-col text-center">
              <h2 className="text-2xl font-bold">No Pending Cards</h2>
              <p className="text-primary-500/40">
                You don&apos;t have any pending cards
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PendingCards;

const CardSkeleton = () => {
  return (
    <div className="h-18 w-full max-w-lg animate-pulse overflow-hidden rounded-xl bg-gray-700 shadow-[rgba(0,_0,_0,_0.25)_0px_25px_50px_-12px]"></div>
  );
};

const Card = ({
  cardData,
  selectedCard,
  setSelectedCard,
}: {
  cardData: PendingCard;
  selectedCard: PendingCard | null;
  setSelectedCard: (card: PendingCard) => void;
}) => {
  const { openSheet } = useSheetStore();
  return (
    <div
      role="button"
      onClick={() => openSheet("pendingCardDetails", null, { cardData })}
      tabIndex={0}
      className={`relative overflow-hidden rounded-xl border border-[#4D698B] p-4 transition-all hover:cursor-pointer active:scale-x-98`}
      style={{
        background:
          "linear-gradient(108.57deg, #B9D2E2 -4.61%, #756C95 97.89%)",
      }}
    >
      <div className="absolute inset-0 z-0 bg-[#6060600D] backdrop-blur-sm" />
      <img
        className="absolute right-0 bottom-0 w-30"
        src="/images/card-lines.svg"
        alt=""
      />
      <img
        className="absolute bottom-0 left-0 h-full"
        src="/images/card-blur2.svg"
        alt=""
      />

      <div className="relative flex h-full w-full items-center justify-between">
        <div>
          <p>
            {cardData.firstName} {cardData.lastName}
          </p>
          <p className="text-xs">{cardData.email}</p>
        </div>
        <div>
          <p className="text-xs">Created Date:</p>
          <p>
            {cardData.createdAt
              ? moment(cardData.createdAt).isSame(moment(), "day")
                ? "Today"
                : moment(cardData.createdAt).isSame(moment().subtract(1, "day"))
                  ? "Yesterday"
                  : moment(cardData.createdAt).fromNow()
              : "-"}
          </p>
        </div>
      </div>
    </div>
  );
};
